import React from 'react';
import {cameraCaptureLabel,CameraPhoto} from '../../services/cameraApi';
import {useTimeFormat} from '../../services/dateTime';
export default function CameraCaptureTime(props:Pick<CameraPhoto,'source_capture_local'|'timezone'|'capture_time_status'>){
 return <>{cameraCaptureLabel(props,useTimeFormat())}</>;
}
